import { setCookie, getCookieJson } from "./helpers/cookie";

/* eslint-disable */
export default (config) => {
    const opts = { ...config };
    const P13N_COOKIE = "snfi_pref";
    const REG_COOKIE = "snfi_reg";
    return {
        opts,
        selectCategory(id) {
            const preferences = this.getPreferences();

            if (preferences.categories.indexOf(id) === -1) {
                preferences.categories.push(id);

                setCookie(P13N_COOKIE, preferences);
            }
        },
        removeCategory(id) {
            const preferences = this.getPreferences();

            if (preferences.categories.indexOf(id) !== -1) {
                preferences.categories = preferences.categories.filter((elem) => {
                    return elem != id;
                });

                setCookie(P13N_COOKIE, preferences);
            }
        },
        getPreferences() {
            let preferences = getCookieJson(P13N_COOKIE);

            if (!preferences) {
                preferences = {
                    categories: [],
                };
            }

            return preferences;
        },
        savePartialRegistration(elem) {
            let partialRegistration = this.getPartialRegistration();
            
            partialRegistration.partialValues[elem.getAttribute('data-schema')] = elem.value;
            
            setCookie(REG_COOKIE, partialRegistration);
        },
        getPartialRegistration() {
            let partialRegistration = getCookieJson(REG_COOKIE);

            if (!partialRegistration) {
                partialRegistration = {
                    partialValues: {},
                };
            }

            return partialRegistration;
        },
    };
};
